module.exports = __webpack_public_path__ + "static/media/mapMarker.3fa66cdc.svg";